import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { removeFromCart } from "../../Features/Cart/cartActions";
import { numberFormatter } from "../../helper/helpers";
import QuantityControl from "./QuantityControl";
import { slugify } from "../../utils/slugify";

const CartSection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { cart } = useSelector((state) => state.itemCart);
  const { isLoggedIn } = useSelector((state) => state.auth);

  let subTotal = cart?.reduce(
    (acc, curr) => acc + (curr.price || curr.unitPrice) * curr.quantity,
    0,
  );

  let total = subTotal;

  const handleRemoveItem = (item) => {
    // item.id || item?.productId
    if (isLoggedIn) {
      dispatch(removeFromCart(item?.productId));
    } else {
      dispatch(removeFromCart(item.id));
    }
  };

  const handleCheckout = () => {
    const isAuthenticated = !!JSON.parse(localStorage.getItem("authUser"));
    if (!isAuthenticated) {
      navigate("/auth/login", {
        state: { from: "/checkout" },
      });
    } else {
      navigate("/checkout");
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (cart.length === 0) {
    return (
      <section className="cart py-80">
        <div className="container-fluid container-lg text-center">
          <img
            src="/assets/images/illustrations/19.svg"
            width={300}
            alt="Logo"
            className="img-fluid"
          />
          <h6 className="mt-20">Your Cart is empty</h6>
          <p className="text-dark">
            <span>
              Start exploring and add items you'd like to purchase and add them
              to cart!
            </span>
          </p>
          <div className="d-flex justify-content-center mt-30">
            <Link
              to="/"
              className="link text-line-2 bg-main-50 hover-bg-main-100 transition-2 text-black rounded-5 py-10 px-20"
              tabIndex={0}
            >
              <i className="ph ph-shopping-cart" /> Shop today's deals
            </Link>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="cart py-80">
      <div className="container container-lg">
        <div className="row gy-4">
          <div className="col-xl-9 col-lg-8">
            <div className="card border-0 shadow-sm">
              <div className="card-header d-flex justify-content-start gap-10">
                <button
                  className="btn btn-sm page-link h-40 w-64 flex-center text-xxl rounded-8 fw-medium hover-bg-main-600 hover-text-white text-neutral-600 border border-gray-100"
                  onClick={handleBack}
                >
                  <i className="ph-bold ph-arrow-left" />
                </button>
                <h6 className="m-0 align-content-center">
                  Cart ({cart.length})
                </h6>
              </div>
              <div className="card-body">
                <ul className="list-group list-group-flush">
                  {cart.map((item) => (
                    <li className="list-group-item" key={item.id}>
                      <div className="d-flex justify-content-between flex-wrap">
                        <div className="hstack gap-20 flex-fill">
                          <span className="table-product__thumb border border-gray-100 rounded-8 flex-center ">
                            <img
                              // src="/assets/images/thumbs/product-two-img1.png"
                              src={item.imageUrl}
                              alt=""
                              className="img-fluid"
                            />
                          </span>
                          <span className="table-product__content text-start">
                            <h6 className="title text-lg fw-semibold mb-8">
                              <Link
                                to={`/products/product-details/${item.id || item?.productId}?name=${slugify(item.name || item?.productName)}`}
                                // to={`/products/product-details/${slugify(item?.name || item?.productName)}`}
                                state={item}
                                className="link text-line-2"
                                tabIndex={0}
                              >
                                {item.name || item?.productName}
                              </Link>
                            </h6>
                            <div className="flex-align my-5 gap-6">
                              {item?.categoryName && (
                                <span className="py-2 px-8 text-xs rounded-pill text-main-600 bg-main-50">
                                  {item?.categoryName}
                                </span>
                              )}
                              <span className="text-sm mt-5 mb-0 fw-semibold">
                                {numberFormatter.format(
                                  Number(item?.price || item?.unitPrice),
                                )}
                              </span>
                            </div>
                            {/* <div className="flex-align gap-16 mb-16">
                              <div className="flex-align gap-6">
                                <span className="text-sm text-warning-600 d-flex">
                                  <i className="ph-fill ph-star" />
                                </span>
                                <span className="text-sm fw-medium text-gray-900">
                                  4.8
                                </span>
                              </div>
                              <span className="text-sm text-gray-200">|</span>
                              <span className="text-neutral-600 text-sm">
                                128 Reviews
                              </span>
                            </div> */}
                            <button
                              className="btn btn-sm rounded-8 text-danger-400 hover-bg-danger-100 hover-text-danger-600 px-10 py-5 text-xs"
                              onClick={() => handleRemoveItem(item)}
                            >
                              <i className="ph ph-trash me-5"></i>{" "}
                              <span className="">Remove</span>
                            </button>
                          </span>
                        </div>
                        <div className="d-flex align-items-center gap-5">
                          <QuantityControl currentItem={item} />
                          <span className="text-md mt-3 mb-0 fw-semibold">
                            {numberFormatter.format(
                              Number(
                                (item?.price || item?.unitPrice) *
                                  item.quantity,
                              ),
                            )}
                          </span>
                        </div>
                      </div>
                      {/* <hr /> */}
                      <div className="d-flex justify-content-end"></div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            {/* <div className="cart-table border border-gray-100 rounded-8 px-40 py-48">
              <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
                <table className="table style-three">
                  <thead>
                    <tr>
                      <th className="h6 mb-0 text-lg fw-bold">Delete</th>
                      <th className="h6 mb-0 text-lg fw-bold">Product Name</th>
                      <th className="h6 mb-0 text-lg fw-bold">Price</th>
                      <th className="h6 mb-0 text-lg fw-bold">Quantity</th>
                      <th className="h6 mb-0 text-lg fw-bold">Subtotal</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <button
                          type="button"
                          className="remove-tr-btn flex-align gap-12 hover-text-danger-600"
                        >
                          <i className="ph ph-x-circle text-2xl d-flex" />
                          Remove
                        </button>
                      </td>
                      <td>
                        <div className="table-product d-flex align-items-center gap-24">
                          <Link
                            to="/product-details-two"
                            className="table-product__thumb border border-gray-100 rounded-8 flex-center "
                          >
                            <img
                              src="assets/images/thumbs/product-two-img1.png"
                              alt=""
                            />
                          </Link>
                          <div className="table-product__content text-start">
                            <h6 className="title text-lg fw-semibold mb-8">
                              <Link
                                to="/product-details"
                                className="link text-line-2"
                                tabIndex={0}
                              >
                                Taylor Farms Broccoli Florets Vegetables
                              </Link>
                            </h6>
                            <div className="flex-align gap-16 mb-16">
                              <div className="flex-align gap-6">
                                <span className="text-md fw-medium text-warning-600 d-flex">
                                  <i className="ph-fill ph-star" />
                                </span>
                                <span className="text-md fw-semibold text-gray-900">
                                  4.8
                                </span>
                              </div>
                              <span className="text-sm fw-medium text-gray-200">
                                |
                              </span>
                              <span className="text-neutral-600 text-sm">
                                128 Reviews
                              </span>
                            </div>
                            <div className="flex-align gap-16">
                              <Link
                                to="/cart"
                                className="product-card__cart btn bg-gray-50 text-heading text-sm hover-bg-main-600 hover-text-white py-7 px-8 rounded-8 flex-center gap-8 fw-medium"
                              >
                                Camera
                              </Link>
                              <Link
                                to="/cart"
                                className="product-card__cart btn bg-gray-50 text-heading text-sm hover-bg-main-600 hover-text-white py-7 px-8 rounded-8 flex-center gap-8 fw-medium"
                              >
                                Videos
                              </Link>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="text-lg h6 mb-0 fw-semibold">
                          $125.00
                        </span>
                      </td>
                      <td>
                        <QuantityControl initialQuantity={1} />
                      </td>
                      <td>
                        <span className="text-lg h6 mb-0 fw-semibold">
                          $125.00
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <button
                          type="button"
                          className="remove-tr-btn flex-align gap-12 hover-text-danger-600"
                        >
                          <i className="ph ph-x-circle text-2xl d-flex" />
                          Remove
                        </button>
                      </td>
                      <td>
                        <div className="table-product d-flex align-items-center gap-24">
                          <Link
                            to="/product-details-two"
                            className="table-product__thumb border border-gray-100 rounded-8 flex-center "
                          >
                            <img
                              src="assets/images/thumbs/product-two-img2.png"
                              alt=""
                            />
                          </Link>
                          <div className="table-product__content text-start">
                            <h6 className="title text-lg fw-semibold mb-8">
                              <Link
                                to="/product-details"
                                className="link text-line-2"
                                tabIndex={0}
                              >
                                Taylor Farms Broccoli Florets Vegetables
                              </Link>
                            </h6>
                            <div className="flex-align gap-16 mb-16">
                              <div className="flex-align gap-6">
                                <span className="text-md fw-medium text-warning-600 d-flex">
                                  <i className="ph-fill ph-star" />
                                </span>
                                <span className="text-md fw-semibold text-gray-900">
                                  4.8
                                </span>
                              </div>
                              <span className="text-sm fw-medium text-gray-200">
                                |
                              </span>
                              <span className="text-neutral-600 text-sm">
                                128 Reviews
                              </span>
                            </div>
                            <div className="flex-align gap-16">
                              <Link
                                to="/cart"
                                className="product-card__cart btn bg-gray-50 text-heading text-sm hover-bg-main-600 hover-text-white py-7 px-8 rounded-8 flex-center gap-8 fw-medium"
                              >
                                Camera
                              </Link>
                              <Link
                                to="/cart"
                                className="product-card__cart btn bg-gray-50 text-heading text-sm hover-bg-main-600 hover-text-white py-7 px-8 rounded-8 flex-center gap-8 fw-medium"
                              >
                                Videos
                              </Link>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="text-lg h6 mb-0 fw-semibold">
                          $125.00
                        </span>
                      </td>
                      <td>
                        <QuantityControl initialQuantity={1} />
                      </td>
                      <td>
                        <span className="text-lg h6 mb-0 fw-semibold">
                          $125.00
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <button
                          type="button"
                          className="remove-tr-btn flex-align gap-12 hover-text-danger-600"
                        >
                          <i className="ph ph-x-circle text-2xl d-flex" />
                          Remove
                        </button>
                      </td>
                      <td>
                        <div className="table-product d-flex align-items-center gap-24">
                          <Link
                            to="/product-details-two"
                            className="table-product__thumb border border-gray-100 rounded-8 flex-center "
                          >
                            <img
                              src="assets/images/thumbs/product-two-img3.png"
                              alt=""
                            />
                          </Link>
                          <div className="table-product__content text-start">
                            <h6 className="title text-lg fw-semibold mb-8">
                              <Link
                                to="/product-details"
                                className="link text-line-2"
                                tabIndex={0}
                              >
                                Taylor Farms Broccoli Florets Vegetables
                              </Link>
                            </h6>
                            <div className="flex-align gap-16 mb-16">
                              <div className="flex-align gap-6">
                                <span className="text-md fw-medium text-warning-600 d-flex">
                                  <i className="ph-fill ph-star" />
                                </span>
                                <span className="text-md fw-semibold text-gray-900">
                                  4.8
                                </span>
                              </div>
                              <span className="text-sm fw-medium text-gray-200">
                                |
                              </span>
                              <span className="text-neutral-600 text-sm">
                                128 Reviews
                              </span>
                            </div>
                            <div className="flex-align gap-16">
                              <Link
                                to="/cart"
                                className="product-card__cart btn bg-gray-50 text-heading text-sm hover-bg-main-600 hover-text-white py-7 px-8 rounded-8 flex-center gap-8 fw-medium"
                              >
                                Camera
                              </Link>
                              <Link
                                to="/cart"
                                className="product-card__cart btn bg-gray-50 text-heading text-sm hover-bg-main-600 hover-text-white py-7 px-8 rounded-8 flex-center gap-8 fw-medium"
                              >
                                Videos
                              </Link>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="text-lg h6 mb-0 fw-semibold">
                          $125.00
                        </span>
                      </td>
                      <td>
                        <QuantityControl initialQuantity={1} />
                      </td>
                      <td>
                        <span className="text-lg h6 mb-0 fw-semibold">
                          $125.00
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <button
                          type="button"
                          className="remove-tr-btn flex-align gap-12 hover-text-danger-600"
                        >
                          <i className="ph ph-x-circle text-2xl d-flex" />
                          Remove
                        </button>
                      </td>
                      <td>
                        <div className="table-product d-flex align-items-center gap-24">
                          <Link
                            to="/product-details-two"
                            className="table-product__thumb border border-gray-100 rounded-8 flex-center "
                          >
                            <img
                              src="assets/images/thumbs/product-two-img4.png"
                              alt=""
                            />
                          </Link>
                          <div className="table-product__content text-start">
                            <h6 className="title text-lg fw-semibold mb-8">
                              <Link
                                to="/product-details"
                                className="link text-line-2"
                                tabIndex={0}
                              >
                                Taylor Farms Broccoli Florets Vegetables
                              </Link>
                            </h6>
                            <div className="flex-align gap-16 mb-16">
                              <div className="flex-align gap-6">
                                <span className="text-md fw-medium text-warning-600 d-flex">
                                  <i className="ph-fill ph-star" />
                                </span>
                                <span className="text-md fw-semibold text-gray-900">
                                  4.8
                                </span>
                              </div>
                              <span className="text-sm fw-medium text-gray-200">
                                |
                              </span>
                              <span className="text-neutral-600 text-sm">
                                128 Reviews
                              </span>
                            </div>
                            <div className="flex-align gap-16">
                              <Link
                                to="/cart"
                                className="product-card__cart btn bg-gray-50 text-heading text-sm hover-bg-main-600 hover-text-white py-7 px-8 rounded-8 flex-center gap-8 fw-medium"
                              >
                                Camera
                              </Link>
                              <Link
                                to="/cart"
                                className="product-card__cart btn bg-gray-50 text-heading text-sm hover-bg-main-600 hover-text-white py-7 px-8 rounded-8 flex-center gap-8 fw-medium"
                              >
                                Videos
                              </Link>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="text-lg h6 mb-0 fw-semibold">
                          $125.00
                        </span>
                      </td>
                      <td>
                        <QuantityControl initialQuantity={1} />
                      </td>
                      <td>
                        <span className="text-lg h6 mb-0 fw-semibold">
                          $125.00
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="flex-between flex-wrap gap-16 mt-16">
                <div className="flex-align gap-16">
                  <input
                    type="text"
                    className="common-input"
                    placeholder="Coupon Code"
                  />
                  <button
                    type="submit"
                    className="btn btn-main py-18 w-100 rounded-8"
                  >
                    Apply Coupon
                  </button>
                </div>
                <button
                  type="submit"
                  className="text-lg text-gray-500 hover-text-main-600"
                >
                  Update Cart
                </button>
              </div>
            </div> */}
          </div>
          <div className="col-xl-3 col-lg-4">
            <div className="cart-sidebar border border-gray-100 rounded-8 px-24 py-40">
              <h6 className="text-xl mb-32">Cart Totals</h6>
              <div className="bg-color-three rounded-8 p-24">
                <div className="mb-32 flex-between gap-8">
                  <span className="text-gray-900 font-heading-two">
                    Subtotal
                  </span>
                  <span className="text-gray-900 fw-semibold">
                    {numberFormatter.format(Number(subTotal))}
                  </span>
                </div>
                {/* <div className="mb-32 flex-between gap-8">
                  <span className="text-gray-900 font-heading-two">
                    Extimated Delivery
                  </span>
                  <span className="text-gray-900 fw-semibold">Free</span>
                </div>
                <div className="mb-0 flex-between gap-8">
                  <span className="text-gray-900 font-heading-two">
                    Extimated Taxs
                  </span>
                  <span className="text-gray-900 fw-semibold">USD 10.00</span>
                </div> */}
              </div>
              <div className="bg-color-three rounded-8 p-24 mt-24">
                <div className="flex-between gap-8">
                  <span className="text-gray-900 text-xl fw-semibold">
                    Total
                  </span>
                  <span className="text-gray-900 text-xl fw-semibold">
                    {numberFormatter.format(Number(total))}
                  </span>
                </div>
              </div>
              {/* <Link
                to="/checkout"
                className="btn btn-main mt-40 py-18 w-100 rounded-8"
              >
                Proceed to checkout
              </Link> */}
              <button
                className="btn btn-main mt-40 py-18 w-100 rounded-8"
                onClick={() => handleCheckout()}
              >
                Proceed to checkout
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CartSection;
